<template>
  <div class="mt-5">
    <div reporter-module="product_description" reporter-appear reporter-appear-duration class="description" v-if="describe.descriptionEn">
      <div class="title pa-2 fs-14 d-flex justify-space-between">
        PRODUCT DESCRIPTION
        <v-icon
          v-if="deviceType != 'PC'"
          :icon="visible ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          class="pointer"
          @click="visible = !visible"
        ></v-icon>
      </div>
      <p class="fs-14 mt-4 pl-1 fc-black-09" v-if="visible">
        {{ describe.descriptionEn }}
      </p>
    </div>

    <div reporter-module="product_specifications" reporter-appear reporter-appear-duration class="specifications title mt-5 pa-2 fs-14 d-flex justify-space-between">
      PRODUCT SPECIFICATIONS
      <v-icon
        v-if="deviceType != 'PC'"
        :icon="contentVisible ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        class="pointer"
        @click="contentVisible = !contentVisible"
      ></v-icon>
    </div>
    <div class="specifications-content mt-4 pl-1 fs-14" v-if="contentVisible">
      <v-row no-gutters class="my-3" v-if="describe.colorOptions">
        <v-col cols="4" class="fb-650 fc-888">Standard Color Options</v-col>
        <v-col
          cols="8"
          class="fc-black-09"
          v-html="describe.colorOptions"
        ></v-col>
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.material">
        <v-col cols="4" class="fb-650 fc-888">Material</v-col>
        <v-col cols="8" class="fc-black-09">{{ describe.material }}</v-col>
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.productSize">
        <v-col cols="4" class="fb-650 fc-888">Product Size</v-col>
        <v-col cols="8" class="fc-black-09">{{ describe.productSize }}</v-col>
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.productWeight">
        <v-col cols="4" class="fb-650 fc-888">Product Weight</v-col>
        <v-col cols="8" class="fc-black-09"
          >{{ describe.productWeight }} lbs</v-col
        >
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.imprintMethod">
        <v-col cols="4" class="fb-650 fc-888">Imprint Method</v-col>
        <v-col cols="8" class="fc-black-09">{{ describe.imprintMethod }}</v-col>
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.imprintArea">
        <v-col cols="4" class="fb-650 fc-888">Imprint Area (inch)</v-col>
        <v-col cols="8" class="fc-black-09">{{ describe.imprintArea }}</v-col>
      </v-row>
      <v-row no-gutters class="my-3" v-if="describe.packingMethod">
        <v-col cols="4" class="fb-650 fc-888">Packing Method</v-col>
        <v-col cols="8" class="fc-black-09">{{ describe.packingMethod }}</v-col>
      </v-row>
      <v-row no-gutters class="my-3">
        <v-col cols="4" class="fb-650 fc-888">Origin</v-col>
        <v-col cols="8" class="fc-black-09">China</v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup>
const { $Utils } = useNuxtApp();
const props = defineProps({
  describe: {
    type: Object,
    default: {}
  }
});
const visible = ref(true);
const contentVisible = ref(true);
const deviceType = $Utils.browserRedirect();
</script>

<style scoped lang="scss">
.title {
  background: #f5f5f5;
  font-weight: 650;
}
</style>
